class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
     if (this.content.getAnimations) {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
       }
    } else {
      console.warn('getAnimations() wordt niet ondersteund in deze browser');
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

 onToggle() {
     if (!this.header || !this.mainDetailsToggle || !this.content) {
      console.warn('Niet alle vereiste elementen zijn beschikbaar. Controleer de header, mainDetailsToggle en content.');
      return;
        }

    this.handleDetailsToggle();
    this.handleAnimations();
 }
  
   handleDetailsToggle() {
    const isOpen = this.mainDetailsToggle.hasAttribute("open");
    this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", isOpen);
  }
  
    handleAnimations() {
   if (this.content.getAnimations) {
    if (!this.animations) {
        this.animations = this.content.getAnimations();
    }
    const isOpen = this.mainDetailsToggle.hasAttribute("open");
    this.animations.forEach(animation => isOpen ? animation.play() : animation.cancel());
   } else {
      console.warn('getAnimations() wordt niet ondersteund in deze browser');
}
  }
}

customElements.define('header-menu', HeaderMenu);
